(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/coupon-choice/coupon-choice.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/coupon-choice/coupon-choice.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback;
const _svs$components$tipse = svs.components.tipsen.routePlaySpela.couponChoice.constants.showCouponChoice,
  COUPON_CHOICE_NONE = _svs$components$tipse.COUPON_CHOICE_NONE,
  COUPON_CHOICE_PIX = _svs$components$tipse.COUPON_CHOICE_PIX,
  COUPON_CHOICE_SETTINGS = _svs$components$tipse.COUPON_CHOICE_SETTINGS;
const CouponToolbox = svs.components.tipsen.routePlaySpela.couponChoice.CouponToolbox;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useIsCouponEmpty = _svs$components$tipse2.useIsCouponEmpty,
  useClearCoupon = _svs$components$tipse2.useClearCoupon;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _svs$components$tipse3 = svs.components.tipsen.tipsinfo,
  useFilteredOutcomeInfoChoises = _svs$components$tipse3.useFilteredOutcomeInfoChoises,
  useFilteredTipsinfoOptions = _svs$components$tipse3.useFilteredTipsinfoOptions;
const CouponChoice = () => {
  const couponId = useCouponId();
  const _useState = useState(COUPON_CHOICE_NONE),
    _useState2 = _slicedToArray(_useState, 2),
    activeChoice = _useState2[0],
    setActiveChoice = _useState2[1];
  const onActivateChoice = useCallback(newActiveChoice => {
    setActiveChoice(oldActiveChoice => {
      if (oldActiveChoice === newActiveChoice) {
        newActiveChoice = COUPON_CHOICE_NONE;
      }
      return newActiveChoice;
    });
  }, [setActiveChoice]);
  const isShowingPix = activeChoice === COUPON_CHOICE_PIX;
  const isShowingSettings = activeChoice === COUPON_CHOICE_SETTINGS;
  const onActivatePix = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_PIX);
  }, [onActivateChoice]);
  const onActivateSettings = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_SETTINGS);
  }, [onActivateChoice]);
  const onActivateNone = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_NONE);
  }, [onActivateChoice]);
  const onClearCoupon = useClearCoupon(couponId);
  const isCouponEmpty = useIsCouponEmpty(couponId);
  const tipsinfoOptions = useFilteredTipsinfoOptions();
  const outcomeInfoChoises = useFilteredOutcomeInfoChoises();
  const idPix = 'expandable-area-pix';
  const idSettings = 'expandable-area-settings';
  return React.createElement("div", {
    className: "coupon-choices"
  }, React.createElement(CouponToolbox, {
    idPix: idPix,
    idSettings: idSettings,
    isCouponEmpty: isCouponEmpty,
    isShowingPix: isShowingPix,
    isShowingSettings: isShowingSettings,
    onActivateNone: onActivateNone,
    onActivatePix: onActivatePix,
    onActivateSettings: onActivateSettings,
    onClearCoupon: onClearCoupon,
    outcomeInfoChoises: outcomeInfoChoises,
    tipsinfoOptions: tipsinfoOptions
  }));
};
setGlobal('svs.components.tipsen.routePlaySpela.couponChoice.CouponChoice', CouponChoice);

 })(window);